import React from 'react';
import _ from 'lodash';
import Stepper from "../../../components/Stepper";
import styled from "styled-components";
import { getErrorStep, getFinalizationStatus } from "../helpers";
import { FINALIZATION_STATUSES } from "../constants";
import { lbl } from "../../../utils/intl";
import {Times} from "../../../components/Icon";
import {Check} from "react-feather";
import {HBox} from "../../../components/Box";

const ERROR = styled.div`
  color: red;
`;
const DONE = styled.div`
  color: #0183D5;
`;
const IN_PROGRESS = styled.div``;

const getErrorSectionMsg = errorStep => {
  return (
    <ERROR>
      <p>Failed to make the invoice {errorStep.stepName}</p>
      <p>Error:</p>
      <p>{errorStep.error}:</p>
    </ERROR>
  );
}

const getDoneMsg = status => {
  return (
    <DONE>
        <p>{lbl(`invoice.details.finalizationStatus.${status}`)}</p>
    </DONE>
  );
}

const getInProgressMessage = status => {
  return (
    <IN_PROGRESS>
      <p>{lbl(`invoice.details.finalizationStatus.${status}`)}</p>
    </IN_PROGRESS>
  );
}

const getStatusMsg = invoice => {
  let status = getFinalizationStatus(invoice);

  if (FINALIZATION_STATUSES.ERROR === status) {
    const errorStep = getErrorStep(invoice);
    return getErrorSectionMsg(errorStep)
  }
  if (FINALIZATION_STATUSES.DONE === status) return getDoneMsg(status);
  if (FINALIZATION_STATUSES.IN_PROGRESS === status) return getInProgressMessage(status);

  return '';
}

export const InvoiceFinalizationStatusBar = props => {
  if (!props.invoice) return '';
  if (!props.invoice.finalizationLog) return '';
  const sortedRawSteps = _.orderBy(Object.values(props.invoice.finalizationLog), ['stepNumber'], ['asc']);
  const stepsDone = sortedRawSteps.filter(r => r.done).length;
  const activeStep = stepsDone;
  const steps = sortedRawSteps.map(r => {
    return  { title: r.stepName, error: !!r.error, done: r.done };
  });

  return (
    <div>
      { !props.disableStatusMsg && getStatusMsg(props.invoice) }
      <Stepper errorColor={'red'} titleFontSize={10} size={32} steps={steps} activeStep={ activeStep } />
    </div>
  );
};

